import { Children, isValidElement, type ReactNode } from 'react';

import { NestedFilterSelectGroup } from './Group';
import { NestedFilterSelectItem } from './Item';

export function findGroupLabelForValue(
  children: ReactNode,
  targetValue: string,
  currentGroup: string | null
): { group: string | null } | null {
  for (const child of Children.toArray(children)) {
    if (!isValidElement(child)) continue;

    if (child.type === NestedFilterSelectItem) {
      const itemProps = child.props as { value: string };
      if (itemProps.value === targetValue) {
        return { group: currentGroup };
      }
      continue;
    }

    if (child.type === NestedFilterSelectGroup) {
      const groupProps = child.props as { label: string; children: ReactNode };
      const match = findGroupLabelForValue(
        groupProps.children,
        targetValue,
        groupProps.label
      );
      if (match !== null) return match;
      continue;
    }

    const wrapperProps = child.props as { children?: ReactNode };
    const match = findGroupLabelForValue(
      wrapperProps.children,
      targetValue,
      currentGroup
    );
    if (match !== null) return match;
  }

  return null;
}
